// TODO: rename "number" property so we can remove the eslint-disable-next-line comments
export class WaremaPlusAccessStep {
    // eslint-disable-next-line id-denylist
    public number: number;
    public iconPath: string;
    public iconWidth: number;
    public iconHeight: number;
    public text: string;

    // eslint-disable-next-line id-denylist
    constructor(number: number, iconPath: string, iconWidth: number, iconHeight: number, text: string) {
        // eslint-disable-next-line id-denylist
        this.number = number;
        this.iconPath = iconPath;
        this.iconWidth = iconWidth;
        this.iconHeight = iconHeight;
        this.text = text;
    }
}
